import {
  V1_AGENT_AUTHORIZED_PATH,
  V1_AGENT_CONSIDERATION_PATH,
  V1_GET_JOBS_AGENT,
  V1_JOBS_PATH,
  V1_PROPOSITON_PATH,
  V1_SAVE_CONDITION_JOB_SEARCH,
} from '@/constant/routers/path';
import request from '@/services/http.service';
import type {
  JobSearchRequest,
  JobSearchResponse,
  ApiResponse,
  AgentAuthResponse,
  AgentJobSearchRequest,
  AgentJobSearchResponse,
  JobPropositionRequest,
} from '@/types/api/jobSearch';

export const getJobSearch = (data: JobSearchRequest): Promise<JobSearchResponse> => {
  return request(V1_JOBS_PATH, {
    method: 'GET',
    params: data,
  });
};

export const getTokenAuthAgent = (): Promise<AgentAuthResponse> => {
  return request(V1_AGENT_AUTHORIZED_PATH, {
    method: 'GET',
  });
};

export const getAgentJobs = (data: AgentJobSearchRequest): Promise<AgentJobSearchResponse> => {
  return request(V1_GET_JOBS_AGENT, {
    method: 'GET',
    params: data,
  });
};

export const createAgentConsideration = (id: number): Promise<ApiResponse> => {
  return request(V1_AGENT_CONSIDERATION_PATH, {
    method: 'POST',
    params: { job_id: id },
  });
};

export const updateAgentConsideration = (id: number): Promise<ApiResponse> => {
  return request(`${V1_AGENT_CONSIDERATION_PATH}/${id}`, {
    method: 'PATCH',
  });
};

export const createJobProposition = (data: JobPropositionRequest): Promise<ApiResponse> => {
  return request(V1_PROPOSITON_PATH, {
    method: 'POST',
    data,
  });
};

export const updateJobProposition = (id: number): Promise<ApiResponse> => {
  return request(`${V1_PROPOSITON_PATH}/${id}`, {
    method: 'PATCH',
  });
};

export const getListConditionJobSearch = (): Promise<ApiResponse> => {
  return request(V1_SAVE_CONDITION_JOB_SEARCH, {
    method: 'GET',
  });
};

export const deleteConditionJobSearch = (id: number): Promise<ApiResponse> => {
  return request(`${V1_SAVE_CONDITION_JOB_SEARCH}/${id}`, {
    method: 'DELETE',
  });
};
